import React from 'react';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { formatNumberFR } from '../../utils/formatFR';
import Bloc from './Bloc';
import { COULEURS_FAMILLES } from './couleurs';

const Camembert = ({ familles, titre, testid }) => {
  const total = familles.reduce((somme, f) => somme + (f.nombre || 0), 0);
  const parts = familles.filter((f) => f.nombre > 0);
  return (
    <div className="min-w-0" data-testid={testid}>
      <p className="text-xs font-semibold text-slate-600 text-center mb-1">{titre}</p>
      <div className="h-56">
        {total === 0 ? (
          <p className="text-sm text-slate-400 text-center pt-20">Aucune donnée</p>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie data={parts} dataKey="nombre" nameKey="libelle" cx="50%" cy="45%"
                   outerRadius="72%" stroke="#fff" strokeWidth={2}>
                {parts.map((f) => (
                  <Cell key={f.cle} fill={COULEURS_FAMILLES[f.cle] || '#94A3B8'} />
                ))}
              </Pie>
              <Tooltip
                formatter={(valeur, nom) => [
                  `${formatNumberFR(valeur)} (${Math.round((100 * valeur) / total)} %)`, nom]}
                contentStyle={{ fontSize: 12, borderRadius: 8 }}
              />
              <Legend
                verticalAlign="bottom"
                height={48}
                wrapperStyle={{ fontSize: 11 }}
                formatter={(valeur, entree) => (
                  <span className="text-slate-600">
                    {valeur} — {Math.round((100 * (entree?.payload?.nombre || 0)) / total)} %
                  </span>
                )}
              />
            </PieChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

/** Familles d'activité — deux camemberts côte à côte avec le portefeuille (lot DI § 5). */
export const GraphiqueFamilles = ({ donnees, portefeuille }) => (
  <Bloc
    titre="Familles d'activité"
    legende="Répartition des ventes par grande famille de métiers (légende en pourcentage)."
    testid="observatoire-graph-familles"
  >
    <div className={portefeuille ? 'grid grid-cols-1 sm:grid-cols-2 gap-2' : ''}>
      <Camembert
        familles={donnees.familles || []}
        titre={portefeuille ? 'Marché (ventes publiées)' : 'Part des ventes publiées'}
        testid="observatoire-camembert-marche"
      />
      {portefeuille && (
        <Camembert
          familles={portefeuille.familles || []}
          titre="Votre portefeuille"
          testid="observatoire-camembert-portefeuille"
        />
      )}
    </div>
  </Bloc>
);

export default GraphiqueFamilles;
